export default `float de( vec3 p ) {
    float e, i = 0.0, j, f, a, w;
    p.yz *= rot( 0.7 );
    f = 0.4;
    i < 45.0 ? p : p -= 0.001;
    e = p.y + 5.0;
    for( a = j = 0.9; j++ < 30.0; a *= 0.8 ) {
      vec2 m = vec2( 1. ) * rot( j );
      
      float x = dot( p.xz, m ) * f + 0.0;
      w = exp( sin( x ) - 1.0 );
      p.xz -= m * w * cos( x ) * a;
      e -= w * a;
      f *= 1.2;
    }
    return e;
  }`